/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для группы товаров (каталог, корзина, избранное и тд.).
   * Создаёт вид для каждого отдельного товара внутри себя.
   *
   * @param el {string} jQuery-селектор родительского элемента
   * @param itemEl {string} jQuery-селектор элемента товара
   */
  app.ItemsView = app.View.extend({
    el: '.backbone-items-view',
    itemEl: '',
    qtyView: 'ItemQtyView',
    itemViews: [],
    additionalOptions: ['isNewMobileProductPage'],

    beforeRun: function () {
      var that = this;
      this.$items = this.$(this.itemEl);
      app.itemPageModel = new app.ItemPage();

      this.$items.each(function () {
        // создаём экземпляр View для каждого Item.
        that.itemViews[that.itemViews.length] = new app.ItemView({
          el: $(this),
          qtyView: that.qtyView,
          isNewMobileProductPage: this.isNewMobileProductPage,
        });
        // сохраняем в модель данные, необходимые для переключению preview товаров.
        app.itemPageModel.saveWtfId(
          parseInt($(this).find('[data-wtf-id]').data('wtf-id'), 10),
          $(this).find('.catalog__item-link').attr('href')
        );
      });
    }

  });
})(jQuery);

}.call(window));